export type NameOf = <T>(name: keyof T) => keyof T;
export const nameof: NameOf = <T>(name: keyof T) => name;
